import React, { lazy, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./coming-events.css";
import { upcomingEvents as upcomingEventsData } from "../../constants/data";
import { Link } from "react-router-dom";
import { FaCalendar, FaMapMarker, FaClock } from "react-icons/fa";

import ComingEventMetadata from "../../components/generateMetadata/ComingEventMetadata";
import { ScrollToTop } from "../../components";

const UpcomingEvents = lazy(() => import("../../components/upcoming-events"));

function convertToSlug(text) {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
}

const ComingEvents = () => {
  const { upcomingEventSlug } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [comingEvent, setComingEvent] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const foundEvent = upcomingEventsData.find(
        (event) => convertToSlug(event.title) === upcomingEventSlug
      );
      if (foundEvent) {
        setComingEvent(foundEvent);
      } else {
        // If no event is found, navigate to a 404 page or show an error
        navigate("/not-found", { replace: true });
      }
      setIsLoading(false);
    };

    fetchEvent();
  }, [upcomingEventSlug, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!comingEvent) {
    return null;
  }

  return (
    <>
      <ComingEventMetadata event={comingEvent} />
      <section
        className="upcomingDetailHeader"
        style={{
          backgroundImage: comingEvent.image
            ? `url(${comingEvent.image})`
            : "none",
        }}
      >
        <div className="blurBkg">
          <div className="container">
            <div className="eventHeader hor">
              <div className="left ver flex">
                <div className="eventTitle">
                  <h1>{comingEvent.title}</h1>
                </div>
                <div className="eventInfo">
                  {comingEvent.date && (
                    <div className="infoItemD">
                      <p>
                        <FaCalendar className="icon" />
                        {comingEvent.date}
                      </p>
                    </div>
                  )}
                  {comingEvent.time && (
                    <div className="infoItemD">
                      <p>
                        <FaClock className="icon" />
                        {comingEvent.time}
                      </p>
                    </div>
                  )}
                  {comingEvent.venue && (
                    <div className="infoItemD">
                      <p>
                        <FaMapMarker className="icon" />
                        {comingEvent.venue}
                      </p>
                    </div>
                  )}
                </div>
                <div className="buyTickets">
                  <Link
                    to={"/donate"}
                    className="btnPrimary bkgRed"
                    style={{ marginTop: "20px" }}
                  >
                    Donate
                  </Link>
                </div>
              </div>
              <div className="right ver flex">
                <div className="imgWrapper">
                  <img src={comingEvent.image} alt={comingEvent.title} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {comingEvent.details && (
        <section className=" eventDetailContent">
          <div className="container grayBackground">
            <div className="detailWrapper">
              <p>{comingEvent.details}</p>
            </div>

            <div className="eventInfo">
              <p className="eventNotice">{comingEvent.notice}</p>
              <p className="eventDate">
                <strong>Date:</strong> {comingEvent.date || "TBA"}
              </p>
              <p className="eventTime">
                <strong>Time:</strong> {comingEvent.time || "TBA"}
              </p>
              <p className="eventLocation">
                <strong>Location:</strong>
                <br /> {comingEvent.location || "TBA"}
              </p>
            </div>

            <div className="eventActions">
              <Link
                to={`/events/upcoming-events/rsvp/${convertToSlug(
                  comingEvent.title
                )}`}
                className="btnSecondary"
              >
                Click here to Rsvp
              </Link>
              <Link to="/donate" className="btnPrimary bkgRed colorWhite">
                Donate
              </Link>
            </div>

            <Link to="/events" className="backLink">
              ← Back to Events
            </Link>
          </div>
        </section>
      )}
      <section className="eventsSection" style={{ marginBottom: "4rem" }}>
        <div className="container">
          <UpcomingEvents />
        </div>
      </section>
      <ScrollToTop />
    </>
  );
};

export default ComingEvents;
